class Coordonnees extends Inscription {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {

		/// Variables et classes
		let self = this;

		const passager = new passagerInscription(config);
		const formulaire = new Formulaire(config.form);
		const utilities = new utilitiesInscription(config);

		let btn = document.getElementById('valideCoordonnees');
		let form = document.getElementById('infosCoordonneesForm');
		let listPax = document.querySelectorAll('.coordonnees__pax');


		/// Initialisation des functions
		super.initialize();
		//super.form();
		this.pax();
		formulaire.initialize('infosCoordonneesForm');

		///
		/// Events

		// Add or delete Pax
		passager.deletePax(self.config.isTravelOnlyAdult);

		let btnsAdd = document.querySelectorAll('.btn--addTraveler');
		for (let btnAdd of btnsAdd) {
			btnAdd.addEventListener('click', function () {
				self.newPax(self.config.isTravelOnlyAdult);
			});
		}


		// Formulaire, mask champ date de naissance et btn de validation
		//form.onsubmit = self._changementTypePassager();
		form.onsubmit = self._changementTypePassager();

		for (var i = 0; i < listPax.length; i++) {
			let inputPaxDateNaissance = document.getElementById(`Inscription_ColInfoVoyageur_${i}__DateNaissance`);
			utilities._maskInput(inputPaxDateNaissance);
		}

		// Cas liberté
		if (config.liberte) {
			btn.addEventListener('click', function (e) {
				self.liberteChangementNbrePassagerModal(btn, formulaire, form, e);
			})
		} else {
			/// Contrôle doublon
			btn.addEventListener('click', function (e) {
				self.saisieControleModal(btn, formulaire, form, e);
			});
		}
	}

	/// @Modal
	/// On vérifie la saisie des coordonnées voyageurs
	/// => contrôle des éléments saisie
	saisieControleModal(btn, formulaireCheck, form, e) {
		let obj = {};

		//btn.addEventListener('click', function (e) {
		let arrayAllPax = [];
		e.preventDefault();
		/// On vérifie que le formulaire est ok avant de vérifier les doublons dans la saisie
		if (formulaireCheck._isFormValid(form)) {
			/// On parcourt la liste des pax
			for (var i = 0; i < document.querySelectorAll('.coordonnees__pax').length; i++) {
				let nom = document.getElementById(`Inscription_ColInfoVoyageur_${i}__Nom`).value;
				let prenom = document.getElementById(`Inscription_ColInfoVoyageur_${i}__Prenom`).value;
				obj = formulaireCheck.controleSaisieCoordonnesDoublons(nom, prenom, '', `Inscription_ColInfoVoyageur_${i}__NomUsage`);

				/// Si le test de controle de saisie renvoie un message
				/// alors le formulaire est erroné et on empêche la soumission
				if (obj.modale) {
					// Fonction appelée lorsque l'on souhaite confirmer les données saisies
					modalPopup.callback = function () {
						if (form.requestSubmit) {
							document.getElementById('infosCoordonneesForm').requestSubmit(btn);
						} else {
							let inputHiddenSuivant = document.createElement('input');
							inputHiddenSuivant.type = 'hidden';
							inputHiddenSuivant.name = e.target.name;
							inputHiddenSuivant.value = e.target.value;
							document.getElementById('infosCoordonneesForm').append(inputHiddenSuivant);
							document.getElementById('infosCoordonneesForm').submit();
						}
						modalPopup.close();
					}

					if (document.getElementById(modalPopup.items.idButtonCancel).tagName === 'A') {
						let btnHtml = '<button role="button" class="btn btn--primary btn--small btn--negative" id="popupCancelButton">Corriger</button>';
						document.getElementById(modalPopup.items.idButtonCancel).parentElement.innerHTML = btnHtml;
					}

					modalPopup.init(obj.messageDoublonNomSaisie, "", "Corriger", obj.libellebouton);

					arrayAllPax.push(false);
				} else {
					arrayAllPax.push(true);
				}
			}
			const formIsOk = arrayAllPax.every(bool => bool);

			if (formIsOk) {
				if (form.requestSubmit) {
					document.getElementById('infosCoordonneesForm').requestSubmit(btn);
				} else {
					let inputHiddenSuivant = document.createElement('input');
					inputHiddenSuivant.type = 'hidden';
					inputHiddenSuivant.name = e.target.name;
					inputHiddenSuivant.value = e.target.value;
					document.getElementById('infosCoordonneesForm').append(inputHiddenSuivant);
					document.getElementById('infosCoordonneesForm').submit();
				}
			}
		} else {
			if (form.requestSubmit) {
				document.getElementById('infosCoordonneesForm').requestSubmit(btn);
			} else {
				let inputHiddenSuivant = document.createElement('input');
				inputHiddenSuivant.type = 'hidden';
				inputHiddenSuivant.name = e.target.name;
				inputHiddenSuivant.value = e.target.value;
				document.getElementById('infosCoordonneesForm').append(inputHiddenSuivant);
				document.getElementById('infosCoordonneesForm').submit();
			}
		}
		//});
	}

	/// @Modal
	/// Sur les circuits liberté, lorsque le nombre de passagers change par rapport à la formule initiale,
	/// on lance une modale demandant de choisir entre poursuivre l'inscription et demander un devis
	liberteChangementNbrePassagerModal(btn, formulaire, form, e) {
		let self = this;
		let msg = {
			popupModificationNbrePassagers: {
				'title': 'Votre demande initiale a été modifiée',
				'texte': `<p>Vous avez modifié le nombre de voyageurs par rapport à votre demande initiale.<br> Les prix seront actualisés en conséquence.</p>`
			},
			popupDevis: {
				'title': 'Demander un devis',
				'texte': `<p>Pour le nombre de personnes que vous venez de renseigner, nous vous proposons de remplir la demande de devis qui suit</p><p><a class="underline" href="${config.url.devis}">Demande de devis</a><p><p> Un conseiller Terres d’Aventure prendra contact avec vous très rapidement pour finaliser votre projet.</p>`
			}
		}

		//btn.addEventListener('click', function (e) {


		e.preventDefault();

		let nbPax = document.getElementById('HiddenNbVoyageurs').value;

			const utilities = new utilitiesInscription(config);
			let stopGo = utilities._poursuiteInscriptionIndiv(nbPax);

			stopGo.then(function (response) {

				if (response) {
					self.saisieControleModal(btn, formulaire, form, e);

				}
				else {
					modalPopup.init(msg.popupDevis.texte, msg.popupDevis.title);
				}
				
			})
		
	}

	_changementTypePassager() {
		document.addEventListener('DOMContentLoaded', function () {
			let msgInfoVoyageurs = document.getElementById('HiddeMessageInfoVoyageurs').value;

			if (msgInfoVoyageurs != '') {
				modalPopup.overrideStyles = false;
				modalPopup.init("", msgInfoVoyageurs);
			}
		})

	}

	/// @Event
	/// Fonction appelée lors de l'ajout d'un passager
	/// Cas générique : on exécute la requête eventAddNewPassager()
	/// Cas liberté/Famille : on ouvre une modale pour demander le type souhaité du nouveau passager
	newPax(adultOnly) {
		let self = this;
		const passager = new passagerInscription(config);

		// setTimeout(function () {
		// 	commons.loader.loading();
		// }, 1);

		if (adultOnly) {
			passager.eventAddNewPassager();
		} else {
			self._modalChoixNewVoyageur();
		}
	}

	/// Si l'on est sur un circuit famille ou liberté,
	/// Une modale est lancée pour choisir le type de passager
	_modalChoixNewVoyageur() {
		const passager = new passagerInscription(config);

		modalPopup.overrideStyles = false;
		modalPopup.init("", "Ajouter un nouveau voyageur");
		document.querySelector(modalPopup.items.popupModal).classList.add('modal--nouveauVoyageur');
		const utilities = new utilitiesInscription(config);
		utilities._templating('modalChoixNewVoyageur', 'popupContent');
		passager.eventAddNewPassager();
	}

	///
	/// Pour les pax déjà connus depuis la page voyageur
	/// On appelle la fonction gérant le message lié à la civilité
	pax() {
		const utilities = new utilitiesInscription(config);
		utilities.initialize();
	}
}